/**
 * Jarvis R-A: Brücke zwischen dem API-Client und dem Bestätigungsfenster.
 *
 * Schreibende Admin-Aktionen antworten mit 428 `approval_required`. Der API-Client ruft
 * requestApproval() auf, das Fenster (ApprovalModal) fragt den Google-Authenticator-Code ab und
 * sendet ihn NUR an /api/admin-mode/approvals/{id}/approve (nie in den Chat). Danach wird dieselbe
 * Anfrage mit X-Approval-Id wiederholt.
 */
export interface ApprovalRequest {
  kind: "approval"
  approvalId: string
  method: string
  path: string
}

export interface AdminModeRequest {
  kind: "enter_admin_mode"
}

export type ApprovalPrompt = ApprovalRequest | AdminModeRequest

type Listener = (prompt: ApprovalPrompt, done: (ok: boolean) => void) => void

let listener: Listener | null = null

export function setApprovalListener(fn: Listener | null): void {
  listener = fn
}

/** true = bestätigt (bzw. Modus aktiv), false = abgebrochen/abgelehnt/kein Fenster vorhanden. */
let context = ""

/** Понятная подпись к ближайшему подтверждению (кто и что), показывается в окне над текстом брокера. */
export function setApprovalContext(text: string): void {
  context = text
}

export function takeApprovalContext(): string {
  const c = context
  context = ""
  return c
}

export function requestApproval(prompt: ApprovalPrompt): Promise<boolean> {
  return new Promise((resolve) => {
    if (!listener) {
      resolve(false)
      return
    }
    listener(prompt, resolve)
  })
}
